export default __webpack_public_path__ + "static/media/welcome.e7be2377.svg";